<script>
    import Currency from "commerce/currency/currency.svelte";

    import { isAppFeatureEnabled } from "commerce/lib/account-details";

    import BillingBox from "./billing-box.svelte";

    import { onQuoteMouseover, onQuoteMouseout } from "../lib/hover-handlers";
    import clickBuy                              from "../lib/click-buy";

    import { standardQuotes as quotes } from "stores/quotes";
    import { waiting }                  from "stores/toggles";

    import css from "../quotes.css";

    export let exchangeType;

    const i18n            = window.strings.exchange;
    const featureDisabled = !isAppFeatureEnabled(exchangeType);

    function quoteAndDelay(quote, idx) {
        return {
            quote,
            delay : (idx % 5) * 100
        };
    }
</script>

<ul class="{`vbox ${css.offers}`}">
    {#each $quotes[exchangeType].map(quoteAndDelay) as {quote = {}, delay}}
        <li
            class="{`hbox ${css.offer}`}"
            data-disabled={quote.tooExpensive || featureDisabled}

            on:click={clickBuy.bind(null, { featureDisabled, quote })}
            on:mouseover={onQuoteMouseover.bind(null, { featureDisabled, quote, exchangeType })}
            on:mouseout={onQuoteMouseout.bind(null, { featureDisabled, quote })}
        >
            <p class="{`serif ${css.amount}`}" data-packageType={quote.type}>
                <Currency
                    type={quote.type}
                    amount={quote.quantity}
                    options={{ hideSilver : true, hideCopper : true }}
                />
            </p>

            <div
                class="{css.offerQuote}"
                data-waiting={$waiting}
                style="transition-delay: {delay}ms, {delay}ms, {delay + 400}ms"
            >
                <Currency
                    type={quote.type === "gems" ? "coins" : "gems"}
                    amount={quote.price || 0}
                />

                <button class="{css.btn}" data-disabled={quote.tooExpensive}>
                    {i18n.trade}
                </button>
            </div>
        </li>
    {/each}

    {#if exchangeType === "gold2gems"}
        <BillingBox />
    {/if}
</ul>